import React from "react";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/all";
import Slider from "react-slick";
import tool1 from "../assets/img/css.png";
import tool2 from "../assets/img/bitbucket.png";
import tool3 from "../assets/img/azure.png";
import tool4 from "../assets/img/js.png";
import tool5 from "../assets/img/docker.png";
import tool6 from "../assets/img/github.png";
import tool7 from "../assets/img/gitlab.png";
import tool8 from "../assets/img/illustrator.png";
import tool9 from "../assets/img/photoshop.png";
import tool10 from "../assets/img/react.png";
import tool11 from "../assets/img/sass.png";
import tool12 from "../assets/img/typescript.png";
import tool13 from "../assets/img/SVG/tailwind.svg";

const Tools = () => {
  const slider = React.useRef(null);
  function SampleNextArrow(props: {
    className: any;
    style: any;
    onClick: any;
  }) {
    const { className, style, onClick } = props;
    return (
      <MdArrowForwardIos
        style={{
          ...style,
          display: "block",
          color: "#fff",
          cursor: "pointer",
        }}
        onClick={onClick}
        className={className}
      />
    );
  }

  function SamplePrevArrow(props: {
    className: any;
    style: any;
    onClick: any;
  }) {
    const { className, style, onClick } = props;
    return (
      <MdArrowBackIosNew
        style={{
          ...style,
          display: "block",
          color: "#fff",
          cursor: "pointer",
        }}
        onClick={onClick}
        className={className}
      />
    );
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 50,
    slidesToShow: 4,
    slidesToScroll: 4,
    easing: "linear",
    pauseOnHover: true,
    nextArrow: (
      <SampleNextArrow
        className=""
        // @ts-ignore
        onClick={() => slider?.current?.slickNext()}
        style=""
      />
    ),
    prevArrow: (
      <SamplePrevArrow
        className=""
        // @ts-ignore
        onClick={() => slider?.current?.slickPrev()}
        style=""
      />
    ),
    autoplay: true,
  };
  return (
    <div>
      <Slider {...settings} ref={slider}>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool10} alt="home" className="img-fluid" />
          </div>
          <small>React</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool10} alt="home" className="img-fluid" />
          </div>
          <small>React Native</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool11} alt="home" className="img-fluid" />
          </div>
          <small>Sass</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool12} alt="home" className="img-fluid" />
          </div>
          <small>TypeScript</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool1} alt="home" className="img-fluid" />
          </div>
          <small>CSS</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool2} alt="home" className="img-fluid" />
          </div>
          <small>BitBucket</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool3} alt="home" className="img-fluid" />
          </div>
          <small>Azure</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool4} alt="home" className="img-fluid" />
          </div>
          <small>Javascript</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool5} alt="home" className="img-fluid" />
          </div>
          <small>Docker</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool6} alt="home" className="img-fluid" />
          </div>
          <small>GitHub</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool7} alt="home" className="img-fluid" />
          </div>
          <small>GitLab</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool8} alt="home" className="img-fluid" />
          </div>
          <small>Adobe Illustrator</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool9} alt="home" className="img-fluid" />
          </div>
          <small>Adobe Photoshop</small>
        </div>
        <div className="d-flex flex-column align-items-center">
          <div className="slider__parent">
            <img src={tool13} alt="home" className="img-fluid" />
          </div>
          <small>Tailwind css</small>
        </div>
      </Slider>
    </div>
  );
};

export default Tools;
